define([
    'common/ui/view/svg/index',
    'common/ui/view/svg/line/bezier-cubic',
    'backbone',
    'victor'
], function(
    SVGView,
    BezierCubicView,
    Backbone,
    Victor
    ) {
    return Backbone.Model.extend({}, {
        build: function(params) {
            var sourceView = params.sourceView;
            var targetView = params.targetView;
            var bendingPoint = params.bendingPoint;
            var offset = params.offset !== undefined ? params.offset : 64;

            /**
             * ユーザビリティのため、bending Point 上を曲線が通過するようにしたい。
             * 3 次の Bezier 曲線を 2 つ連結し、bending Point を真ん中の点と
             * することで、これを達成する。
             *
             * また、それぞれの Node から垂直に線が生えるようにするために、
             * starting, ending Point それぞれの法線 Vector を計算し、
             * それらを control Point の決定に利用する。
             *
             * bending Point から sourceView, targetView の中心に線を引き
             * それぞれの border(offset あり) と交わった点を
             * starting Point, ending Point とする。
             */
            var sourceCenterPoint = sourceView.getCenterPoint();
            var targetCenterPoint = targetView.getCenterPoint();

            // 見込む角度を計算(rad)
            var sourceCenter2Bending = bendingPoint.clone()
                .subtract(sourceCenterPoint);
            var targetCenter2Bending = bendingPoint.clone()
                .subtract(targetCenterPoint);

            // starting, ending Point を取得
            var startingPoint = sourceView
                .getBorderPoint(sourceCenter2Bending, offset);
            var endingPoint = targetView
                .getBorderPoint(targetCenter2Bending, offset);

            // それぞれの法線を取得し Control Point を計算
            var sNorm = sourceView
                .getBorderTangent(sourceCenter2Bending);
            var eNorm = targetView
                .getBorderTangent(targetCenter2Bending);
            var startingControlPoint = startingPoint.clone()
                .add(sNorm.clone().multiply(Victor(192, 192)));
            var endingControlPoint = endingPoint.clone()
                .add(eNorm.clone().multiply(Victor(192, 192)));

            /**
             * bending, starting Control, ending Control Point の成す三角形で
             * bending Point を頂点とする角を二等分する線分を引き、
             * それに対する法線を伸ばした点を途中の
             * 制御点(bending Control Point)とする。
             */
            var sAngle = startingControlPoint.clone()
                .subtract(bendingPoint)
                .angleDeg();
            var eAngle = endingControlPoint.clone()
                .subtract(bendingPoint)
                .angleDeg();
            var bendingControlAngle = (sAngle + eAngle) / 2 + 90;
            if(bendingControlAngle < 0) {
                bendingControlAngle += 360;
            }
            if(bendingControlAngle > 360) {
                bendingControlAngle -= 360;
            }
            if(bendingControlAngle - sAngle > 90 ||
                bendingControlAngle - sAngle < -90) {
                bendingControlAngle -= 180;
            }
            var controlLength = startingControlPoint.clone()
                    .subtract(bendingPoint).length() / 5 +
                endingControlPoint.clone()
                    .subtract(bendingPoint).length() / 5;
            var bendingControlPoint = bendingPoint.clone()
                .add(Victor(controlLength, 0).rotateDeg(bendingControlAngle));

            return BezierCubicView.Builder()
                .addPoint(startingPoint, startingControlPoint)
                .addPoint(bendingPoint, bendingControlPoint)
                .addPoint(endingPoint, endingControlPoint)
                .build();
        }
    });
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/normal-line-factory.js